<template>
  <div id="app">
    <div id="mySidenav" class="sidenav">
      <a href="#" class="closebtn" @click="closeNav">&times;</a>
      <span v-if="msupport">
            <router-link to="/support"><span><i class="fa fa-wrench" aria-hidden="true"></i>  Support</span></router-link>
      </span>
      <span v-if="!business_on" @click="closeNav">
          <router-link to="/faq"><span style="cursor: help"><i class="fa fa-question" aria-hidden="true"></i>  FaQ  </span></router-link>
          <router-link  to="/client"><span><i class="fa fa-home" aria-hidden="true"></i>  Home</span></router-link>
          <router-link  to="/history"><span><i class="fa fa-database" aria-hidden="true"></i> History</span></router-link>
          <router-link  to="/new_appointment"><span><i class="fa fa-calendar" aria-hidden="true"></i> New</span></router-link>
          <router-link  to="/profile"><span><i class="fa fa-user-circle" aria-hidden="true"></i> Profile</span></router-link>
          <a id="share_link_customer" @click="shareSERPI">
              <span><i class="fa fa-share-alt" aria-hidden="true"></i> Share</span>
          </a>
      </span>
      <span v-else @click="closeNav">
          <span v-if="isSignin">
              <router-link to="/bfaq"><span style="cursor: help"><i class="fa fa-question" aria-hidden="true"></i>  FAQ</span></router-link>
              <router-link  to="/features"><span><i class="fa fa-home" aria-hidden="true"></i> Home</span></router-link>
              <router-link  to="/business_offices"><span><i class="fa fa-map-marker" aria-hidden="true"></i> Offices</span></router-link>
              <router-link  to="/new_business"><span><i class="fa fa-id-badge" aria-hidden="true"></i> BData</span></router-link>
              <router-link  to="/business_appointments"><span><i class="fa fa-calendar" aria-hidden="true"></i> Appo's</span></router-link>
          </span>
          <span v-else>
              <router-link to="/bfaq"><span style="cursor: help"><i class="fa fa-question" aria-hidden="true"></i>  FAQ</span></router-link>
              <router-link  to="/business_signin"><span><i class="fa fa-home" aria-hidden="true"></i> Home</span></router-link>
          </span>
          <a id="share_link_business" @click="shareSERPI">
              <span style="cursor: context-menu"><i class="fa fa-share-alt" aria-hidden="true"></i> Share</span>
          </a>
           <span v-show="isSignin">
               <a id="logout" @click="logout"><span style="cursor: context-menu"><i class="fa fa-sign-out" aria-hidden="true"></i> Logout</span></a>
           </span>
        </span>
    </div>
    <div id="main">
      <!--<div class="pwalabel">sAPPo</div>&nbsp;-->
      <span class="ulip">
                  <a href="http://www.ulip.ee" target="_blank">
                      <span style="font-size: 10px;float: left;color:white">by</span>
                      <img :src="require('./assets/logoUlip100x100.svg')"  style="background-color: white;width: 25px;float: left" alt="logo-ulip">
                  </a>
      </span>
      <span class="btnmenu" @click="openNav">&#9776;</span>&nbsp;
      <button class="btnbusiness" @click="switch_UI">
        <i v-show="business_on" style="color: white" class="fa fa-briefcase" aria-hidden="true"></i>
        <i v-show="!business_on" style="color:white" class="fa fa-user" aria-hidden="true"></i>
      </button>
      <span style="font-size: 14px"> {{changeToUIString}}</span>
      <router-link v-if="business_on" to="/bfaq" style="text-decoration: none">
        <span style="cursor: help;font-size: 15px;color: white;margin-left: 10px;"><i class="fa fa-question" aria-hidden="true"></i>  FAQ  </span>
      </router-link>
      <router-link v-else to="/faq" style="text-decoration: none">
        <span style="cursor: help;font-size: 15px;color: white;margin-left: 10px;"><i class="fa fa-question" aria-hidden="true"></i>  FAQ  </span>
      </router-link>
      <a v-show="business_on" class="pricelabel" href="mailto:?to=dnan66@gmail.com&subject=Request Trial Code &body=Hello sAPPo!">
        Request Trial
      </a>
      <span v-show="!business_on" class="pricelabel">Free</span>
      <span style="float:right;font-size: 10px">v {{ version }}</span>
      <hr>
      <router-view/>
    </div>
  </div>
</template>
<script>
    export default {
        name:'App',
        data() {
            return {
                serpi_link:'https://safe-plains-39478.herokuapp.com/',
            }
        },
        beforeCreate() {
            //console.log('beforeCreate App hook')
            // trying to detect force reload on browser - use of button 'reload'

            if (window.performance) {
                if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
                    //console.info( "Reload detected" );
                    localStorage.setItem('hard_reload',1)
                    this.$router.push('/')  // go always at start
                } else {
                    //console.info( "Reload not detected");
                }
            } else {
                //console.info("window.performance is not supported");
            }
        },
        mounted() {
            if(!localStorage.getItem('hard_reload')) {
                //nothing to do
                //console.info( "Reload not detected");
            } else {
                //console.info( "Reload detected" );
                this.eraseDataFromStore()
                localStorage.removeItem('hard_reload')
            }
        },
        computed:{
            changeToUIString() {
               return this.$store.getters.getBusiness ? 'business' : ' client'
            },
          version() {
            let pkg = require('../package.json')
            return pkg.version
          },
            business_on() {
                //console.log('business on:',this.$store.getters.getBusiness)
                return this.$store.getters.getBusiness
            },
            isSignin() {
              return this.$store.getters.getLoginState
            },
            msupport() {
                const msuppo = localStorage.getItem('msuppo')
                const check = !msuppo ? 'no' : msuppo
                return !!check.match('69bd7de4f45da9d7a12bde4102cf25db97db6d0df6b98f130b64cfe9a6a2b12d')
            }
        },
        methods: {
            eraseDataFromStore() {
                // set flag for logout
                this.$store.commit('setLoginState',false)
                // erase data from store
                this.$store.commit('setCurrentBusiness',null)
                this.$store.commit('setNumberOffices',null)
                this.$store.commit('setLiveAppointments',null)
                this.$store.commit('setSuspendedAccount',null)
            },
            switch_UI() {
                this.$store.commit('setBusinessUi',!this.$store.getters.getBusiness)
                if(this.$store.getters.getBusiness) {
                    //console.log('switch to business UI')
                    this.$router.push('/business_signin')
                }else {
                    //console.log('switch to customer UI')
                    this.eraseDataFromStore()
                    this.$router.push('/client') //client
                }
            },
            logout() {
                this.eraseDataFromStore()
                this.$router.push('/business_signin')
            },
            openNav() {
                document.getElementById("mySidenav").style.width = "90px";
                document.getElementById("main").style.marginLeft = "90px";
            },
            closeNav() {
                document.getElementById("mySidenav").style.width = "0";
                document.getElementById("main").style.marginLeft= "0";

            },
            shareSERPI() {
                if(navigator.share) {
                    // share supported
                    navigator.share({
                        title:'Share New App : SaPPo',
                        url: this.serpi_link
                    }).then(()=>{
                        alert('Thank You for sharing!')
                    }).catch( err => {
                        alert('Error when sharing sappo :'+err.message)
                    })
                } else {
                  // implement fall-back
                  let share_app = !document.getElementById('share_link_customer') ? document.getElementById('share_link_business') : document.getElementById('share_link_customer')
                  share_app.href = 'mailto:?to=&subject=Share New App SaPPo &body=' + this.serpi_link
                }
            }
        },

    }
</script>
<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: white;
    background-color: black;
  }
  #nav {
    padding: 30px;
    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
  .sidenav {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: white;
    overflow-x: hidden;
    transition: 0.5s;
    padding-top: 60px;
  }

  .sidenav a {
    padding: 8px 8px 8px 0;
    text-decoration: none;
    font-size: 13px;
    color: black;
    display: block;
    transition: 0.3s;
  }

  .sidenav a:hover {
    color: red;
  }

  .sidenav .closebtn {
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 36px;
    margin-left: 40px;
  }

  #main {
    transition: margin-left .5s;
    padding: 16px;
  }

  @media screen and (max-height: 450px) {
    .sidenav {padding-top: 15px;}
    .sidenav a {font-size: 10px;}
  }
  .pwalabel {
    display: inline-block;
    padding-top: 5px;
    height: 20px;
    width: 45px;
    background-color: limegreen;
    color:white;
    border-radius: 50%;
    font-weight: bold;
    font-size: 12px;
    margin-left: 5px;
    margin-right: 5px;
  }

  .version {
    display: inline-block;
    height: 14px;
    width: 30px;
    background-color: lightsalmon;
    border-radius: 0;
    font-weight: bold;
    font-size: 10px;
  }
  .pricelabel {
      height: 14px;
      background-color: yellow;
      color: #000;
      border-radius: 10%;
      font-size: 10px;
      padding: 2px 2px 2px 2px;
      margin-left: 5px;
      float:right;
      text-decoration: none;
  }

  .customer {
    font-size: 9px;
    padding-top: 3px;
  }
    .btnbusiness {
        background-color: black;
        border: none;
        cursor: alias;
        border-radius: 16px;
        font-size: 15px;
    }
    .btnbusiness:hover {
        background-color: dodgerblue;
        font-size: 18px;
    }
    .mainmsg {
        font-size: 14px;
        color: whitesmoke;
    }
    .btnmenu {
        font-size: 24px;
        cursor: context-menu;
    }

    .btnmenu:hover {
        background-color: dodgerblue;
    }

  @media screen and (max-width: 601px) {
      .pwalabel {
          height: 20px;
          width: 40px;
          font-size: 10px;
      }
      .mainmsg {
          font-size: 10px;
      }
  }
    @media screen and (max-width:430px ) {
        .ulip {
            display: none
        }
    }
</style>
